import { useMemo } from 'react'
import { useQuery } from 'react-query'

import { useBalanceConfig } from '@features/balanceLedger'

import { defaultStaleTime } from '../../../config/queryClient'

export interface SupplierAccountOption {
  contactId: string
  accountNumber: string
  name: string
}

interface UseFetchCreditorBalanceSummaryAccountsParams {
  organizationId: string
  period?: string
  enabled: boolean
}

interface UseFetchCreditorBalanceSummaryAccountsResult {
  accounts: SupplierAccountOption[]
  isLoading: boolean
}

export const useFetchCreditorBalanceSummaryAccounts = ({
  organizationId,
  period,
  enabled,
}: UseFetchCreditorBalanceSummaryAccountsParams): UseFetchCreditorBalanceSummaryAccountsResult => {
  const config = useBalanceConfig()
  const queryKey = [config.querySummaryAccountsKey, organizationId, period]

  const { data, isLoading, isIdle } = useQuery(
    queryKey,
    () => config.fetchSummaryAccounts({ organizationId, period }),
    {
      enabled: enabled && !!organizationId,
      staleTime: defaultStaleTime,
    },
  )

  const accounts = useMemo<SupplierAccountOption[]>(
    () =>
      (data?.contacts ?? [])
        .map((contact) => ({
          contactId: contact.contactId,
          accountNumber: contact.auxiliaryAccountNo ?? '',
          name: contact.contactName,
        }))
        .sort((a, b) => a.name.localeCompare(b.name)),
    [data?.contacts],
  )

  return { accounts, isLoading: isIdle || isLoading }
}
